<template>
  <v-app>
    <v-main>
      <v-container>
        <v-layout justify-center>
          <v-flex xs12 sm12 md12 lg12 xl6>
            <v-card>
              <v-card-title class="pb-5">
                <!--                                    v-if="$can('transaction_create')"-->
                <!--                <v-btn @click="$router.push({name: 'notifications.index'})"  class="btn-back">-->
                <!--                  <span class="flaticon2-reply icon-lg" ></span>-->
                <!--                  بازگشت-->
                <!--                </v-btn>-->
                <!--                <v-spacer/>-->
                <!--                {{ $t($route.meta.title) }}-->
                <!--                <v-spacer/>-->
                <v-btn
                  @click="updateNotification"
                  :loading="loading"
                  class="btn-update"
                >
                  <v-icon>mdi-update</v-icon>
                  بروز رسانی
                </v-btn>
                <!--                            <v-card elevation="2" outlined>-->
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                      v-model="title"
                      label="عنوان"
                      required
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-select
                      v-model="notify_type"
                      :items="notify_types"
                      item-text="value"
                      v-on:change="notifyStatus"
                      item-value="name"
                      outlined
                      dense
                      return-object
                      label="نوع اطلاع رسانی"
                    >
                    </v-select>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <v-text-field
                      v-model="cost"
                      label="نرخ پیامک"
                      :disabled="!textArea"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 xl6 class="p-2">
                    <date-picker
                      v-model="extras.notify_at"
                      label="تاریخ ارسال"
                      format="YYYY-MM-DD HH:mm"
                      type="datetime"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      outlined
                      dense
                    >
                    </date-picker>
                  </v-flex>
                </v-row>
                <v-row>
                  <v-flex xs12 sm12 md12 lg12 xl12 class="p-2">
                    <ckeditor
                      v-if="ckEditor"
                      :editor="editor.editor"
                      v-model="text"
                      :config="editor.editorConfig"
                    ></ckeditor>

                    <v-textarea
                      v-if="textArea"
                      v-model="text"
                      dense
                      outlined
                      label="متن پیام"
                    ></v-textarea>
                  </v-flex>
                </v-row>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";
import error from "@/view/pages/error/Error";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  props: ["id"],
  data() {
    return {
      loading: false,
      title: "",
      text: "",
      ckEditor: false,
      textArea: true,
      notify_type: "",
      notify_types: [
        { name: "sms", value: "پیامک" },
        { name: "email", value: "ایمیل" },
        { name: "notification", value: "اطلاع رسانی" },
        { name: "push_notification", value: "اطلاع رسانی پنل" },
      ],
      cost: "",
      users: [],
      extras: {
        notify_at: "",
      },
      editor: {
        editor: ClassicEditor,
        editorConfig: {
          extraPlugins: [CKEditorUploadAdapterPlugin],
        },
      },
    };
  },
  methods: {
    updateNotification() {
      this.loading = true;
      this.requestApiPost(`notification/${this.id}`, {
        title: this.title,
        text: this.text,
        notify_type: this.notify_type,
        cost: this.cost,
        extras: this.extras,
        users: this.users,
        _method: "PUT",
      })
        .then((response) => {
          this.loading = false;
          this.$toast.success("اطلاع رسانی با موفقیت ارسال شد.");
          this.$router.push({ name: "notifications.index" });
        })
        .catch(({ response }) => {
          this.errors = response.data;
          this.loading = false;
        });
    },
    findNotification() {
      this.requestApiGet(`notification/${this.id}`)
        .then(({ data }) => {
          this.title = data.data.title;
          this.text = data.data.text;
          this.notify_type = data.data.notify_type;
          this.cost = data.data.cost;
          this.extras = data.data.extras;
          this.users = data.data.users;
        })
        .catch((error) => {});
    },
    notifyStatus(data) {
      if (data.name === "sms") {
        this.ckEditor = false;
        this.textArea = true;
      } else {
        this.textArea = false;
        this.ckEditor = true;
        this.cost = "";
      }
    },
  },

  created() {
    this.findNotification();
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);
  },
};
</script>
